import "./commercial.css";

const TICKER_SELECTOR = "[data-commercial-logo-ticker]";
const PRIMARY_GROUP_SELECTOR = "[data-commercial-logo-ticker-primary]";
const STATIC_CLASS = "is-static";

function syncTickerState(ticker) {
  const primaryGroup = ticker.querySelector(PRIMARY_GROUP_SELECTOR);
  if (!primaryGroup) return;

  const primaryContentWidth = primaryGroup.getBoundingClientRect().width;
  const canFitPrimaryContent = primaryContentWidth <= ticker.clientWidth + 1;

  ticker.classList.toggle(STATIC_CLASS, canFitPrimaryContent);
}

function bindTicker(ticker) {
  const sync = () => syncTickerState(ticker);
  const primaryImages = ticker.querySelectorAll(`${PRIMARY_GROUP_SELECTOR} img`);

  window.addEventListener("load", sync);
  window.addEventListener("resize", sync);

  if (typeof ResizeObserver === "function") {
    const observer = new ResizeObserver(sync);
    observer.observe(ticker);
    primaryImages.forEach((image) => observer.observe(image));
  }

  primaryImages.forEach((image) => {
    if (!image.complete) {
      image.addEventListener("load", sync, { once: true });
    }
  });

  requestAnimationFrame(sync);
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(TICKER_SELECTOR).forEach(bindTicker);
});
